/**
 * Typography matched to reference PDF proportions (794 pt wide → A4 595.28 pt).
 * Reference: hero 55.5 / 42 / 14 pt, section title 18 pt, body 14 pt.
 */
export const PDF_FONTS = {
  heroTitle: 42,
  heroSubtitle: 31.5,
  body: 10.5,
  sectionTitle: 13.5,
  checklistMeta: 9,
  caption: 8.5,
} as const;

export const PDF_COLOR_HERO_TITLE = '#7A92B8';
